import React, { useCallback, useMemo, } from 'react';
import { IPreviewMailMessage, ISharedMailMessageAttachmentProperty, } from 'atlas-shared';
import { AttachmentIcon, DownloadIcon, ImageIcon, } from '@Assets/icons';
import { Tag, } from 'antd';
import { TFunction, } from 'i18next';
import { Icon, IconText, } from '@Components';
import { actionDocsPreview, } from '@Store';
import { fetchDownloadMailMessageAttachment, } from '@Api';
import { AlertError, preventDefault, } from '@Utils';

interface IProps {
  dispatch: any;
  organization_id: IPreviewMailMessage['organization_id'];
  mail_message_id: IPreviewMailMessage['id'];
  attachment: ISharedMailMessageAttachmentProperty;
  attachments: Array<ISharedMailMessageAttachmentProperty>;
  index: number;
  anonymized: boolean;
  t: TFunction;
  stringRendered?: boolean;
}

export const ConversationMessageMailAttachment = React.memo(({ dispatch, organization_id, mail_message_id, attachment, attachments, index, t, stringRendered = false, anonymized: _anonymized, }: IProps) => {

  const anonymized = _anonymized || !!attachment.anonymized_at;

  const error = useMemo(() => t('FILE_NOT_FOUND', {
    replace: {
      filename: attachment.filename,
    },
  }), [attachment, ]);

  const onClick = useCallback(() => {
    if (anonymized)
      return;

    return dispatch(actionDocsPreview({
      index,
      docs: attachments.map(attachment => ({ uri: `mail_message/p/${organization_id}/${mail_message_id}/attachment/${attachment.unique_filename || attachment.filename}`, filename: attachment.filename, })),
    }));
  }, [attachments, index, ]);

  const onDownload = () => {
    return fetchDownloadMailMessageAttachment(organization_id, mail_message_id, attachment.unique_filename || attachment.filename, attachment.filename, () => {
      AlertError(t, {
        content: error,
        title: t('NOT_FOUND'),
      });
    });
  };

  const icon = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', ].includes(attachment.contentType) ? ImageIcon : AttachmentIcon;

  const url = `javascript:fetchDownloadMailMessageAttachment(${organization_id}, ${mail_message_id}, '${attachment.unique_filename || attachment.filename}', '${attachment.filename}', e => alert(e.toString()))`;

  if (stringRendered)
    return (
      <a href={url}>
        <Tag className={'clickable'}>
          <IconText icon={icon} text={attachment.filename || attachment.cid} />
        </Tag>
      </a>
    );

  return <Tag className={`clickable attachment${anonymized ? ' anonymized' : ''}`} onClick={onClick}>
    <IconText icon={icon} text={anonymized ? t('ANONYMIZED') : attachment.filename || attachment.cid} />
    {!anonymized && <Icon icon={DownloadIcon} className='download' onClick={preventDefault(onDownload)}/>}
  </Tag>;
});
